import React, { useMemo } from 'react';
import { DropdownMenu } from '../common';
import { getCompetitiveHostMenuItems } from '../../utils/competitivePlayerHostActions';
import { COMPETITIVE_HOST_PLAYER_MENU_PROPS } from './competitiveHostPlayerMenuProps';

const getPlayerDisplayName = (player) =>
  player?.name || `${player?.first_name || ''} ${player?.last_name || ''}`.trim() || 'Player';

/**
 * Compact ⋯ overflow menu for competitive host player actions (Courts waitlist rows).
 */
const CompetitivePlayerOverflowMenu = ({
  player,
  hostActionContext,
  excludeKeys = [],
  className = '',
  disabled = false,
  /** When set with onMenuOpenPlayerIdChange, only one row menu is open at a time. */
  menuOpenPlayerId = null,
  onMenuOpenPlayerIdChange,
}) => {
  const items = useMemo(() => {
    if (!player || !hostActionContext) return [];
    return getCompetitiveHostMenuItems(player, hostActionContext, { excludeKeys });
  }, [player, hostActionContext, excludeKeys]);

  if (!items.length) return null;

  const displayName = getPlayerDisplayName(player);

  const menuOpenProps =
    typeof onMenuOpenPlayerIdChange === 'function'
      ? {
          open: menuOpenPlayerId === player.id,
          onOpenChange: (open) => onMenuOpenPlayerIdChange(open ? player.id : null),
        }
      : {};

  return (
    <DropdownMenu
      {...COMPETITIVE_HOST_PLAYER_MENU_PROPS}
      {...menuOpenProps}
      trigger={
        <button
          type="button"
          disabled={disabled}
          aria-label={`Player actions for ${displayName}`}
          aria-haspopup="menu"
          title="Player actions"
          className={`relative inline-flex h-6 w-6 shrink-0 touch-manipulation items-center justify-center rounded-full border border-border-medium bg-surface text-text-muted shadow-sm transition before:absolute before:-inset-2 before:content-[''] hover:border-border hover:bg-surface-subtle hover:text-text-primary focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 disabled:opacity-50 ${className}`}
        >
          <span className="relative text-sm font-bold leading-none" aria-hidden>
            ⋯
          </span>
        </button>
      }
      items={items}
    />
  );
};

export default CompetitivePlayerOverflowMenu;
